import { GADS_ID } from "@/lib/google-tags";

const CONSENT_STORAGE_KEY = "cookieConsent";

/** Etykieta konwersji z Google Ads, np. AbCdEfGhIjK (część po AW-xxx/). */
const CONVERSION_LABEL =
  process.env.NEXT_PUBLIC_GOOGLE_ADS_CONVERSION_LABEL?.trim();

function hasMarketingConsent(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw) as { marketing?: boolean };
    return parsed.marketing === true;
  } catch {
    return false;
  }
}

/**
 * Wywołaj po udanym wysłaniu formularza kontaktowego.
 * - GTM: event `contact_form_submit` (agencja może na nim oprzeć konwersję)
 * - Google Ads: gtag conversion, gdy jest etykieta i zgoda marketingowa
 */
export function trackContactFormConversion(): void {
  if (typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "contact_form_submit",
    form_name: "contact",
  });

  if (typeof window.gtag !== "function") return;

  window.gtag("event", "generate_lead", {
    event_category: "contact",
    event_label: "contact_form",
  });

  if (!hasMarketingConsent() || !CONVERSION_LABEL || !GADS_ID) return;

  window.gtag("event", "conversion", {
    send_to: `${GADS_ID}/${CONVERSION_LABEL}`,
  });
}
